import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyOverlayRef } from 'src/app/core/services/overlay/myoverlay-ref';
import { StoreConfigurationRepositoryService } from 'src/app/core/services/store-configuration/store-configuration-repository.service';

@Component({
  standalone: true,
  selector: 'webstore-about-bidding-overlay',
  templateUrl: './about-bidding-overlay.component.html',
  styleUrls: ['./about-bidding-overlay.component.scss'],
  imports: [CommonModule]
})
export class AboutBiddingOverlayComponent {
  ref = inject(MyOverlayRef);
  storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);

  // Signal-based approach - no need for Observable wrapper
  get storeConfiguration() {
    return this.storeConfigurationRepositoryService.storeConfigurations();
  }

}

